import store from '@/store';

export default {
  handleError: (ex) => {
    console.log('Exception Handler: ' + ex.toString());
    store.commit(
      'app/showToast',
      {
        color: 'error',
        message: ex.toString(),
        timeout: 5000
      },
      { root: true }
    );
  }
};
